import { cva } from 'class-variance-authority';

import s from './ListItem.module.css';

export const listItemVariants = cva(s.listItem, {
  defaultVariants: {
    prefixSpacing: 0,
    suffixSpacing: 0,
    variant: 'default',
  },
  variants: {
    prefixSpacing: {
      0: s['listItem--prefix-0'],
      1: s['listItem--prefix-1'],
      2: s['listItem--prefix-2'],
      3: s['listItem--prefix-3'],
    },
    suffixSpacing: {
      0: s['listItem--suffix-0'],
      1: s['listItem--suffix-1'],
      2: s['listItem--suffix-2'],
      3: s['listItem--suffix-3'],
    },
    variant: {
      accent: s['listItem--accent'],
      alt: s['listItem--alt'],
      default: s['listItem--default'],
      selected: s['listItem--selected'],
      success: s['listItem--success'],
      warning: s['listItem--warning'],
    },
  },
});
